var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4931_117672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.298729 8.68141L4.61473 1.08984C5.16296 1.42146 7.92749 2.99336 8.37396 3.29231L4.05796 10.8843C3.58595 11.525 -0.299271 9.65367 0.298729 8.68099V8.68141Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6993 8.68184L8.38331 1.09074C7.77993 0.0590577 6.48044 -0.315864 5.41306 0.293475C4.34569 0.902814 4.02069 2.21541 4.62408 3.29316L8.94008 10.8852C9.54346 11.9164 10.843 12.2913 11.9104 11.682C12.9311 11.0726 13.3027 9.71348 12.6993 8.68273V8.68184Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16653 11.9741C3.36307 11.9741 4.33306 11.0023 4.33306 9.80346C4.33306 8.60464 3.36307 7.63281 2.16653 7.63281C0.969989 7.63281 0 8.60464 0 9.80346C0 11.0023 0.969989 11.9741 2.16653 11.9741Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4931_117672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google-ads.484431c679d209a654afbc842c6aafd0.svg";
export { ForwardRef as ReactComponent };